import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import ReportDailyLoanReleasesDetailed from "../reports/ReportDailyLoanReleasesDetailed";


function DailyLoanReleasesDetailed() {
    return (
        <>
            <NavMain slug="daily-loan-releases-detailed" parent="3" />
            <HeaderMain slug="daily-loan-releases-detailed" />
            <div className="main-content">
                <ReportDailyLoanReleasesDetailed />
            </div>
        </>
    );
}

export default DailyLoanReleasesDetailed;